/**
 * Значения из БД, в которых лежит ключ перевода (например
 * `interface.workplace.terms.place`), показываем переведёнными, а обычный
 * пользовательский текст — как есть.
 *
 * Тот же приём используется для любых переводимых справочников из БД:
 * текст в базе заменяем ключом, сам перевод — в `/locales`.
 */

/** i18n из window.$nuxt (тот же способ, что в остальных утилитах). */
export function getI18n() {
  if (typeof window !== 'undefined' && window.$nuxt?.$i18n) {
    return window.$nuxt.$i18n
  }

  return null
}

/**
 * Значение является существующим ключом перевода.
 * @param {string} value
 * @param {Object} [i18n]
 * @returns {boolean}
 */
export function isTranslationKey(value, i18n = getI18n()) {
  if (!value || typeof value !== 'string') return false

  return Boolean(i18n?.te(value))
}

/**
 * Переводит значение из БД, если оно хранит ключ перевода.
 * Отсутствующий ключ (пользовательский текст) возвращается как есть.
 * @param {string} value
 * @param {{ form?: string, i18n?: Object }} [options] - form: форма термина из локалей
 * @returns {string}
 */
export function translateDbValue(value, { form, i18n = getI18n() } = {}) {
  if (!value) return ''

  if (form) {
    const formKey = `${value}.${form}`

    if (i18n?.te(formKey)) return i18n.t(formKey)

    // Формы нет в локали — отдаём базовую форму термина, а не путь ключа.
    const baseKey = `${value}.nominative`

    return i18n?.te(baseKey) ? i18n.t(baseKey) : value
  }

  const baseKey = `${value}.nominative`

  if (i18n?.te(baseKey)) return i18n.t(baseKey)

  return isTranslationKey(value, i18n) ? i18n.t(value) : value
}

export default { getI18n, isTranslationKey, translateDbValue }
